"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var compose = function compose() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (initial) {
    return fns.reduceRight(function (result, fn) {
      return fn(result);
    }, initial);
  };
};

exports.default = compose;


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/lib/compose/index.js
// module id = 98
// module chunks = 0